import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog';
import { Header } from '@jetbrains/ring-ui/components/island/island';
import styles from './constituent-dialog.css';
export function ConstituentDialog(props) {
    const { children, titleLogo, title } = props;
    return (_jsxs(Dialog, { show: true, contentClassName: styles.wrapper, children: [_jsx(Header, { children: _jsxs("div", { className: styles.header, children: [titleLogo && _jsx("span", { className: styles.logoWrapper, children: titleLogo }), _jsx("span", { className: styles.title, children: title })] }) }), children] }));
}
